import { parseFloatUniversal } from "../utils/numberUtils";
export var ParameterFieldType;
(function (ParameterFieldType) {
    ParameterFieldType["None"] = "None";
    ParameterFieldType["U8"] = "U8";
    ParameterFieldType["U16"] = "U16";
    ParameterFieldType["U32"] = "U32";
    ParameterFieldType["U64"] = "U64";
    ParameterFieldType["I64"] = "I64";
    ParameterFieldType["S"] = "S";
    ParameterFieldType["DT"] = "DT";
})(ParameterFieldType || (ParameterFieldType = {}));
export function convertValueToFieldType(value, type) {
    switch (type) {
        case ParameterFieldType.None:
            return value;
        case ParameterFieldType.U8:
        case ParameterFieldType.U16:
        case ParameterFieldType.U64:
            return parseFloatUniversal(value);
        case ParameterFieldType.I64:
            return parseFloatUniversal(value);
        case ParameterFieldType.S:
            return '' + value;
        case ParameterFieldType.DT:
            return new Date(value);
    }
    return null;
}
